import { formatAsCurrency } from '../utils.js';

// Import SVG sprite
const icons = new URL('../../images/sprite.svg', import.meta.url);

class PledgeView {
  constructor() {
    this._parentEl = document.querySelector('#modal');
    this._handlers = {};

    // Bind event handlers
    this._parentEl.addEventListener('click', this._handleSelect.bind(this));
    this._parentEl.addEventListener('submit', this._handleSubmit.bind(this));
  }

  registerHandler(type, handler) {
    // 1) Create empty array if there are no handlers for this type
    if (!this._handlers[type]) this._handlers[type] = [];

    // 2) Register callback
    this._handlers[type].push(handler);
  }

  _publishEvent(type, data = null) {
    // 1) Return if there are no handlers for this type
    if (!this._handlers[type]) return;

    // 2) Call registered handlers and pass in data
    this._handlers[type].forEach((handler) => {
      handler(data);
    });
  }

  _handleSubmit(e) {
    // 1) Prevent browser from reloading page
    e.preventDefault();

    // 2) Get amount entered by user and convert to number
    const pledgeAmount = Number(new FormData(e.target).get('pledge-amount'));

    // 3) Publish submit event
    this._publishEvent('submit', pledgeAmount);
  }

  _handleSelect(e) {
    // 1) Get clicked pledgebox
    const pledgebox = e.target.closest('.pledgebox');

    // 2) Return if click happened outside pledgebox or pledgebox disabled
    if (!pledgebox || pledgebox.classList.contains('pledgebox--disabled'))
      return;

    // 3) Make all pledgeboxes inactive
    Array.from(document.querySelectorAll('.pledgebox')).forEach((e) =>
      e.classList.remove('is-selected')
    );

    // 4) Make clicked pledgebox active
    pledgebox.classList.add('is-selected');

    // 5) Get numerical id from clicked pledgebox
    const id = Number(pledgebox.dataset.tierId);

    // 6) Publish select event
    this._publishEvent('select', id);
  }

  _generatePledgeboxMarkup(data) {
    const { id, title, text, minPledge, hasReward, stock } = data;

    const _generateStockMarkup = () => {
      return `
        <div class="stock stock--small pledgebox__stock">
          <span class="stock__number stock__number--small">${stock}</span>
          <span class="stock__label">left</span>
        </div>
      `;
    };

    return `
      <div class="pledgebox ${
        hasReward && stock < 1 ? 'pledgebox--disabled' : ''
      }" data-tier-id="${id}">
        <div class="pledgebox__upper-container">
          <div class="pledgebox__radiobutton"></div>

          <header class="pledgebox__header">
            <h4 class="heading pledgebox__title">${title}</h4>
            <span class="label-minimum">Pledge ${formatAsCurrency(
              minPledge
            )} or more</span>
          </header>

          <p class="paragraph pledgebox__body">
            ${text}
          </p>

          ${hasReward ? _generateStockMarkup() : ''}
        </div>

        <div class="pledgebox__lower-container">
          <p class="paragraph ta-center">
            Enter your pledge
          </p>

          <form class="pledgebox__form">
            <input type="number" name="pledge-amount" class="pledgebox__input" min="${minPledge}" step="0.01" required>
            <input type="submit" class="btn btn-primary" value="Continue">
          </form>
        </div>
      </div>
    `;
  }

  render(data) {
    // 1) Clear parent container
    this._parentEl.innerHTML = '';

    // 2) Generate markup
    const markup = `
      <div class="modal__content">
        <button class="btn btn-ghost btn-ghost--dark modal__button close-modal">
          <svg class="btn__icon">
            <use href="${icons}#close-modal"></use>
          </svg>
        </button>

        <h2 class="heading heading-secondary">
          Back this project
        </h2>

        <p class="paragraph">
          Want to support us in bringing Mastercraft Bamboo Monitor Riser out in the world?
        </p>

        ${data.map(this._generatePledgeboxMarkup).join('')}
      </div>
    `;

    // 3) Add elements to the DOM
    this._parentEl.insertAdjacentHTML('afterbegin', markup);

    // 4) Make parent visible
    this._parentEl.classList.add('is-open');

    // 5) Add event listener to close button
    this._parentEl
      .querySelector('.close-modal')
      .addEventListener('click', this._hide.bind(this));
  }

  _hide() {
    // 1) Remove content from parent
    this._parentEl.innerHTML = '';

    // 2) Make parent invisible
    this._parentEl.classList.remove('is-open');
  }
}

export default new PledgeView();
